export const CURRENCY = 'NZD';
export const LOCALE = 'en-NZ';
export const STYLE = 'currency';
